var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.619 10H12.381C11.0681 10 10 11.0681 10 12.381V27.619C10 28.9319 11.0681 30 12.381 30H27.619C28.9319 30 30 28.9319 30 27.619V12.381C30 11.0681 28.9319 10 27.619 10ZM25.7171 18.7252C25.6079 18.7359 25.4983 18.7414 25.3886 18.7419C24.7962 18.742 24.213 18.5945 23.6919 18.3129C23.1707 18.0312 22.7279 17.6242 22.4033 17.1286V22.6224C22.4033 23.4255 22.1652 24.2105 21.719 24.8783C21.2728 25.546 20.6387 26.0664 19.8967 26.3738C19.1548 26.6811 18.3384 26.7615 17.5507 26.6048C16.763 26.4482 16.0395 26.0614 15.4717 25.4936C14.9038 24.9257 14.5171 24.2022 14.3604 23.4145C14.2037 22.6269 14.2841 21.8105 14.5915 21.0685C14.8988 20.3265 15.4192 19.6924 16.087 19.2462C16.7547 18.8 17.5398 18.5619 18.3429 18.5619C18.4276 18.5619 18.5105 18.5695 18.5938 18.5748V20.5757C18.5105 20.5657 18.4286 20.5505 18.3429 20.5505C17.7932 20.5505 17.2661 20.7688 16.8775 21.1575C16.4888 21.5461 16.2705 22.0732 16.2705 22.6229C16.2705 23.1725 16.4888 23.6996 16.8775 24.0883C17.2661 24.4769 17.7932 24.6952 18.3429 24.6952C19.4876 24.6952 20.4986 23.7933 20.4986 22.6486L20.5186 13.3181H22.4329C22.5203 14.1499 22.8974 14.9244 23.4981 15.5063C24.0988 16.0882 24.8849 16.4405 25.719 16.5014V18.7252",
    fill: "url(#paint0_linear_5611_41973)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5611_41973",
    x1: 10,
    y1: 20,
    x2: 30,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3912D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A312D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtIcon);
export default __webpack_public_path__ + "static/media/tt-icon.709fbb48bdd9425c1d8e9c5074941815.svg";
export { ForwardRef as ReactComponent };